<template>
  <section class="two-factor-challenge" aria-label="Verificación de acceso">
    <p v-if="fallbackDelivery" role="status">Estamos teniendo problemas con el envío de SMS. El código se ha enviado por correo de manera excepcional a <strong>{{ fallbackDelivery.destination }}</strong>. Su método habitual seguirá siendo SMS.</p>
    <p v-else-if="pending">Enviaremos un código por {{ pending.channel === 'sms' ? 'SMS' : 'email' }} a <strong>{{ pending.destination }}</strong>.</p>
    <p>El código caduca a los cinco minutos. No lo comparta con nadie.</p>
    <button type="button" :disabled="busy || cooldown > 0" @click="send">{{ cooldown > 0 ? `Reenviar en ${cooldown} s` : 'Enviar código' }}</button>
    <form @submit.prevent="verify">
      <label :for="inputId">{{ recovery ? 'Código de recuperación' : 'Código de verificación' }}</label>
      <input :id="inputId" v-model="code" :inputmode="recovery ? 'text' : 'numeric'" autocomplete="one-time-code" :maxlength="recovery ? 27 : 6" :disabled="busy" required>
      <button type="submit" :disabled="busy || !code.trim()">{{ busy ? 'Procesando…' : 'Confirmar' }}</button>
    </form>
    <button v-if="pending && pending.purpose !== 'enroll'" type="button" class="secondary" :disabled="busy" @click="recovery = !recovery; code = ''">{{ recovery ? 'Usar código recibido' : 'Usar un código de recuperación' }}</button>
    <button type="button" class="secondary" :disabled="busy" @click="cancel">Cancelar</button>
    <p v-if="message" role="status">{{ message }}</p>
    <p v-if="error" role="alert">{{ error }}</p>
  </section>
</template>
<script>
import { twoFactorRepository } from '../api/twoFactorRepository';
export default {
  props: { pending: { type: Object, required: true }, inputId: { type: String, default: 'two-factor-code' } },
  data: () => ({ code: '', busy: false, error: '', message: '', recovery: false, cooldown: 0, timer: null, delivery: null }),
  computed: {
    fallbackDelivery() {
      const delivery = this.delivery || this.pending.delivery;
      return delivery && delivery.fallback ? delivery : null;
    }
  },
  beforeDestroy() { clearInterval(this.timer); this.code = ''; },
  methods: {
    async send() {
      this.busy = true; this.error = ''; this.message = '';
      try {
        const result = await twoFactorRepository.post('send');
        if (!result.sent) throw new Error('No se ha confirmado el envío.');
        this.delivery = result;
        this.message = 'Código enviado. Si solicita otro, el anterior dejará de funcionar.';
        this.cooldown = 60; clearInterval(this.timer);
        this.timer = setInterval(() => { this.cooldown = Math.max(0, this.cooldown - 1); if (!this.cooldown) clearInterval(this.timer); }, 1000);
      } catch (e) {
        this.delivery = { fallback: false };
        this.error = e.message;
        if (this.pending.channel === 'sms' && this.pending.purpose === 'enroll') this.error += ' Si no puede recibir SMS, cancele y seleccione email para activar la verificación por correo.';
      }
      finally { this.busy = false; }
    },
    async verify() {
      this.busy = true; this.error = '';
      try {
        const result = await twoFactorRepository.post('verify', { code: this.code.trim() });
        if (!result.success) throw new Error('No se ha confirmado la verificación.');
        this.code = ''; this.$emit('verified', result);
      } catch (e) { this.error = e.message; }
      finally { this.busy = false; }
    },
    async cancel() {
      this.busy = true; this.error = '';
      try { await twoFactorRepository.post('cancel'); this.$emit('cancelled'); }
      catch (e) { this.error = e.message; }
      finally { this.busy = false; }
    }
  }
};
</script>
<style scoped>
.two-factor-challenge { display: grid; gap: 12px; text-align: left; width: 100%; }
form { display: grid; gap: 10px; }
input { width: 100%; box-sizing: border-box; min-height: 44px; padding: 10px; border: 1px solid var(--color-outline, #aab3c3); border-radius: 8px; color: inherit; background: var(--color-surface, #fff); }
button { min-height: 44px; padding: 10px 16px; border: 1px solid var(--color-outline, #aab3c3); border-radius: 8px; cursor: pointer; background: var(--primary, #008bab); color: #fff; }
button.secondary { background: transparent; color: inherit; }
button:disabled { opacity: .55; cursor: default; }
[role=alert] { color: #b3261e; }
</style>
